<template>
  <div class="calendar-small-component">
    <notification v-if="showNotificationBell">
      <template>
        <div v-if="reportNotification && reportNotification.length > 0">
          <p v-for="(entry, index) in reportNotification"
                      :key="index"
                      :entry="entry">
            {{entry.year}}-{{entry.month}} har {{entry.count}} dage der ikke er godkendt endnu.
            </p>
        </div>
      </template>
      <template v-if="false">
        <div>Don't render the template, if there's nothing to display</div>
      </template>
      <template>
        <div v-if="false">
          Content can also be hidden like this.
        </div>
      </template>
    </notification>
    <div class="calendar-small__spacer--admin">
    </div>
    <div class="scroll-view">
      <calendar-entry v-for="(entry, index) in allocations"
                      :key="index"
                      :entry="entry"
                      :allocationTypes="allocationTypes"
                      :circles-lookup="circles"
                      @click.native="openSidebar(entry)">                      
      </calendar-entry>
      <b-button type="is-warning" class="viking-button" size="is-large" icon-left="angle-down" @click="loadMore()" style="margin-bottom: 65px;">
        Hent flere
      </b-button>
    </div>
    <div >
      
    </div>
  </div>
</template>

<script>
import moment, { ISO_8601 } from "moment";
import CalendarEntry from "./calendar-small/CalendarEntry.vue";
import Notification from "@/components/common/Notification.vue";
import { mapActions, mapGetters } from "vuex";
import ApiState from "../../enums/APISTATE";
import Vue from 'vue';

export default {
  name: "calendar-small",
  components: { CalendarEntry, Notification },
  data: () => ({
    calendarData: [],
    editing: undefined,
    showNotificationBell: false
  }),
  async mounted() {
    if (this.viewAsEmployee) {
      this.getReportNotification(this.viewAsEmployee.id);
    } else{
      this.getReportNotification();
    }
    
  },
  methods: {
    ...mapActions("allocations", ["updateAllocation", "setAllocations"]),
    ...mapActions("entrySidebar", ["entrySidebarOpen", "entrySidebarOpenAsync"]),
    ...mapActions("reportStore", ["getReportNotification"]),
    ...mapActions("confirmationModalStore",["setErrorModalText", "setErrorModalOpen", "setConfirmationButtonText"]),
    async openSidebar(entry) {
      if(!entry.employeeId) {
        return;
      }
      entry.canEdit = true;

      await this.entrySidebarOpenAsync(entry).then(async (response) => {
        if(response.action === "update") {
          const { model } = response;
          if(model) {            
            await this.updateAllocation(model);
          
            const idx = this.allocations.findIndex(o => o.id === this.allocation.id);
            if(idx !== -1) {
              Vue.set(this.allocations, idx, this.allocation);
              this.setAllocations(this.allocations);
            }else{
              this.$emit('onUpdated');
            }            
          }          
        }

        if(response.action === "notification") {
          this.$emit('onUpdated');
        }
        if(response.action === "split") {
          this.$emit('onSplit');
        }
      })
      .catch((error) => console.error(error));
    },
    loadMore(){
      if(this.allocations && this.allocations.length > 0) {
        this.$emit('loadMore');
      }
    }
  },
  computed: {
    ...mapGetters("employees", ["employees"]),
    ...mapGetters("reportStore", ["reportNotification"]),
    ...mapGetters("metadata", ["allocationTypes"]),
    ...mapGetters("circles", ["circleApiState", "circles"]),
    ...mapGetters("allocations", ["allocationsApiState", "allocations", "allocationApiState", "allocation"]),
    ...mapGetters(["isAdmin", "viewAsEmployee"]),
    loading() {
      return this.circleApiState !== ApiState.LOADED;
    },
    notificationLabel(){
      if(this.reportNotification) {
        let label = '';
        this.reportNotification.forEach(element => {
          label += `<p>${element.year}-${element.month} har ${element.count} dage der ikke er godkendt</p>`
        });
        return label;
      }
      return null;
    }
  },
  watch: {
    'reportNotification'(newValue){

      if(!newValue) {
        return;
      }

      if(newValue.length >0 ) {
        this.showNotificationBell = false;
        this.showNotificationBell = true;
      }
    },
    'viewAsEmployee'(newValue){
      if(!newValue) {
        return;
      }
      this.getReportNotification(newValue.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar-small-component {
  .calendar-small__spacer--admin {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #c9c8c8;
    padding: 1.25em;
    padding-bottom: 0;
  }
}
.calendar-header {
  font-size: 24px;
  font-weight: 700;
  padding-top: 20px;
  padding-bottom: 10px;
}
.scroll-view {
  padding: 10px;
}
// @media only screen and (max-width: 500px) {
//   .calendar-entry {
//     font-size: 22vw !important;
//   }
// }
</style>
